var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataBanner360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 50,
    viewBox: "0 0 265 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 50,
    rx: 5,
    fill: "#2A3882"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2040_18019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 265,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 50,
    rx: 5,
    fill: "#2A3882"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2040_18019)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 194.861,
    cy: 51.0466,
    r: 33.9147,
    stroke: "#7E8EE4",
    strokeWidth: 1.35659,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4.07"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.86,
    cy: 50.3682,
    r: 60.3682,
    stroke: "#7E8EE4",
    strokeWidth: 1.35659,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4.07"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.364,
    y: 8.99219,
    width: 16.0805,
    height: 16.2791,
    rx: 8.04027,
    fill: "#FF7A59"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2040_18019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.458 15.7564V14.8097C195.713 14.6917 195.876 14.4343 195.879 14.1527V14.1312C195.879 13.7289 195.552 13.4017 195.149 13.4017H195.128C194.726 13.4017 194.399 13.7289 194.399 14.1312V14.1527C194.399 14.4343 194.562 14.689 194.82 14.8097V15.7564C194.46 15.8127 194.122 15.9602 193.838 16.1882L191.245 14.1688C191.263 14.1017 191.274 14.032 191.274 13.9649C191.274 13.5117 190.909 13.1443 190.456 13.1416C190.003 13.1416 189.636 13.5063 189.633 13.9596C189.63 14.4128 189.998 14.7802 190.451 14.7829C190.593 14.7829 190.732 14.7454 190.856 14.6729L193.412 16.6602C192.942 17.3709 192.956 18.2935 193.444 18.9907L192.666 19.7685C192.604 19.7497 192.537 19.739 192.473 19.7363C192.1 19.7363 191.8 20.0394 191.8 20.4095C191.8 20.7822 192.103 21.0826 192.473 21.0826C192.846 21.0826 193.146 20.7822 193.146 20.4095C193.146 20.3424 193.135 20.278 193.114 20.2164L193.884 19.4467C194.79 20.144 196.091 19.975 196.791 19.0685C197.488 18.1621 197.319 16.8613 196.413 16.1614C196.131 15.9495 195.804 15.8101 195.458 15.7564ZM195.139 18.8674C194.551 18.8835 194.063 18.4195 194.047 17.8349C194.031 17.2475 194.495 16.7594 195.08 16.7433C195.098 16.7433 195.12 16.7433 195.139 16.7433C195.726 16.7648 196.185 17.2556 196.163 17.8429C196.144 18.3981 195.697 18.8459 195.139 18.8674Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.771,
    y: 42.2295,
    width: 21.7054,
    height: 21.7054,
    rx: 10.8527,
    fill: "#1AB4D7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2040_18019)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8527,
    height: 10.8527,
    transform: "translate(156.198 47.6558)",
    fill: "#1AB4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.624 58.5087C164.621 58.5087 167.05 56.0793 167.05 53.0824C167.05 50.0855 164.621 47.656 161.624 47.656C158.627 47.656 156.198 50.0855 156.198 53.0824C156.198 56.0793 158.627 58.5087 161.624 58.5087Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 141.275,
    y: 5.60156,
    width: 13.5659,
    height: 13.5659,
    rx: 6.78295,
    fill: "#95BF47"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2040_18019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.666 9.87743C150.659 9.8382 150.626 9.81205 150.594 9.81205C150.561 9.81205 149.986 9.79897 149.986 9.79897C149.986 9.79897 149.502 9.32825 149.456 9.28249C149.41 9.23673 149.312 9.2498 149.28 9.26288C149.28 9.26288 149.188 9.28903 149.038 9.33479C149.011 9.2498 148.972 9.15173 148.92 9.04713C148.75 8.72024 148.495 8.54372 148.194 8.54372C148.175 8.54372 148.155 8.54372 148.129 8.55026C148.122 8.53718 148.109 8.53064 148.103 8.51757C147.972 8.37374 147.802 8.30836 147.599 8.3149C147.207 8.32797 146.815 8.6091 146.501 9.11251C146.279 9.46555 146.109 9.91012 146.056 10.2566C145.605 10.3939 145.291 10.492 145.285 10.4985C145.056 10.5704 145.05 10.577 145.023 10.7927C145.004 10.9562 144.402 15.5653 144.402 15.5653L149.397 16.4283L151.561 15.8922C151.555 15.8856 150.672 9.91665 150.666 9.87743ZM148.789 9.41325C148.672 9.44593 148.541 9.4917 148.403 9.53092C148.403 9.33479 148.377 9.05367 148.286 8.81831C148.58 8.87715 148.724 9.21057 148.789 9.41325ZM148.135 9.61592C147.874 9.69437 147.586 9.7859 147.299 9.87089C147.377 9.56361 147.534 9.25634 147.717 9.05367C147.789 8.98175 147.887 8.89676 147.998 8.84446C148.116 9.07328 148.142 9.39363 148.135 9.61592ZM147.606 8.57641C147.697 8.57641 147.776 8.59602 147.841 8.63525C147.737 8.69409 147.632 8.77254 147.534 8.87715C147.286 9.1452 147.096 9.56361 147.017 9.96242C146.782 10.0343 146.547 10.1062 146.331 10.1716C146.468 9.544 146.998 8.59602 147.606 8.57641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.594 9.812C150.561 9.812 149.986 9.79893 149.986 9.79893C149.986 9.79893 149.502 9.32821 149.456 9.28244C149.436 9.26283 149.417 9.25629 149.391 9.24976V16.4217L151.555 15.8856C151.555 15.8856 150.672 9.91661 150.665 9.87085C150.659 9.83816 150.626 9.812 150.594 9.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.188 10.9233L147.939 11.8648C147.939 11.8648 147.658 11.734 147.325 11.7602C146.835 11.7929 146.835 12.1001 146.835 12.1786C146.861 12.597 147.966 12.6885 148.031 13.6758C148.077 14.4537 147.619 14.9833 146.959 15.0225C146.161 15.0748 145.723 14.6041 145.723 14.6041L145.893 13.885C145.893 13.885 146.331 14.2184 146.684 14.1922C146.913 14.1792 146.998 13.9896 146.991 13.8588C146.959 13.3096 146.057 13.3423 145.998 12.4401C145.952 11.6817 146.449 10.9103 147.547 10.8449C147.972 10.8122 148.188 10.9233 148.188 10.9233Z",
    fill: "#95BF47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_18019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.94101,
    height: 8.13953,
    fill: "white",
    transform: "translate(189.434 13.062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2040_18019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8527,
    height: 10.8527,
    fill: "white",
    transform: "translate(156.198 47.6558)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2040_18019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.13953,
    height: 8.13953,
    fill: "white",
    transform: "translate(143.989 8.3147)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBanner360);
export default __webpack_public_path__ + "static/media/DataBanner360.26e4e2d9.svg";
export { ForwardRef as ReactComponent };